"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _default = exports.default = _Tabs.default;